import axios from 'axios'

export default {
  login (username, password) {
    const body = {
      UserName: username,
      Password: password
    }
    return axios.post('/user/authenticate', body)
      .then(response => {
        if (response.data.ResultCode === 'Success') {
          localStorage.setItem('user', JSON.stringify(response.data))
        }
        return response.data
      })
  },
  logout (rootObject) {
    localStorage.removeItem('user')
    rootObject.courseKey = null
    rootObject.courseName = null
    rootObject.courseScouterType = null
    rootObject.courses = null
    rootObject.scouterKey = null
    rootObject.userFullName = null
  },
  register (userName, password, courseKey, scouterKey, invitationId) {
    const body = {
      UserName: userName,
      Password: password,
      CourseKey: courseKey,
      ScouterKey: scouterKey,
      InvitationId: invitationId
    }
    return axios.post('/user/register', body)
      .then(response => {
        if (response.data.ResultCode === 'Success') {
          localStorage.setItem('user', JSON.stringify(response.data))
        }
        return response.data
      })
  },
  changePassword (scouterKey, oldPwd, newPwd) {
    const body = {
      ScouterKey: scouterKey,
      OldPassword: oldPwd,
      NewPassword: newPwd
    }
    return axios.put('/user/pwd', body)
      .then(response => {
        return response.data
      })
  },
  forgotPassword (emailAddress) {
    const msg = {
      EmailAddress: emailAddress
    }
    return axios.post('/user/forgot', msg)
      .then(response => {
        return response.data
      })
  }
}
